import React from 'react';
import { FormField } from 'iris-react-ui';
import Button from 'material-ui/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Panel from '../../../components/Panel';


const styles = () => ({
  root: {
    opacity: '1',
    border: '1px solid #ccc',
    padding: 0,
    '&:focus-within': {
      border: '1px solid #66afe9',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  dropdown: {
    border: '1px solid #ccc',
    padding: '5px 0 0px 12px',
  },
  dropdownLeft: {
    marginRight: '10px',
  },
  dropdownRight: {
    marginLeft: '10px',
  },
  btn: {
    marginTop: '20px',
  },
  btnRed: {
    marginTop: '20px',
    backgroundColor: '#d9534f',
  },
  container: {
    padding: '20px',
    margin: '20px 0',
  },
  open: {
    color: '#d9534f',
    border: '1px solid #eee',
    borderLeftWidth: '4px',
    borderLeftColor: '#d9534f',
  },
  closed: {
    color: '#5cb85c',
    border: '1px solid #eee',
    borderLeftWidth: '4px',
    borderLeftColor: '#5cb85c',
  },
  scheduled: {
    color: '#f0ad4e',
    border: '1px solid #eee',
    borderLeftWidth: '4px',
    borderLeftColor: '#f0ad4e',
  },
  title: {
    margin: '0',
    fontSize: '19px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
  },
  subTitle: {
    fontSize: '16px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: '700',
    lineHeight: '3em',
    color: '#000',
  },
  description: {
    color: '#000',
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  textArea: {
    display: 'block',
    width: '100%',
    height: 'auto',
    padding: '6px 12px',
    marginTop: '5px',
    resize: 'none',
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    lineHeight: '1.42857',
    color: '#555555',
    backgroundColor: 'white',
    backgroundImage: 'none',
    border: '1px solid #CCCCCC',
    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
  },
  message: {
    color: '#282828',
    fontWeight: 'bold',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontSize: '16px',
    textAlign: 'center',
  },
  input: {
    paddingLeft: '15px',
  },
});

const getDropdown = (data, classes, onChange, value) => (
  <Select
    className={classes.dropdown}
    value={value}
    onChange={onChange}
    disableUnderline
    inputProps={{
      name: data.name,
      id: data.id,
    }}
  >
    {data.options.map((item, index) => <MenuItem key={index} value={item.value}>{item.label}</MenuItem>)}
  </Select>
);

const IncidentManagement = (props) => {
  const {
    manageIncidents, platformHealth, pastIncidents, onChange, status, level, classes,
  } = props;
  return (
    <div className={classes.pageWtrapper}>
      <Panel
        id="platformHealthPanel"
        title={platformHealth.title}>
        <div className={classes.message}>{platformHealth.message}</div>
      </Panel>
      <Panel
        id="manageIncidentsPanel"
        title={manageIncidents.title}>
        <FormField
          classes={{ root: classes.root }}
          inputClasses={{ input: classes.input }}
          startAdornment={getDropdown(manageIncidents.status, classes, onChange, status)}
          endAdornment={getDropdown(manageIncidents.level, classes, onChange, level)}
          label="Incident Information"
          placeholder="Incident Title"
        />
        <textarea className={classes.textArea} type="text" id="additionalInfo" rows="8" placeholder="Enter Additional Information" />
        <Button className={classes.btn}>Create</Button>
        <Button className={classes.btnRed}>Clear</Button>
      </Panel>

      <Panel
        id="pastIncidentsPanel"
        title={pastIncidents.title}>
        <div>
          {pastIncidents.content.map((item, index) => {
            const containerClass = `${classes.container} ${classes[item.status.value]}`;
            return (
              <div key={index} className={containerClass}>
                <h3 className={classes.title}>{`${item.status.label} - ${item.title}`}</h3>
                {item.list.map((subItem, ind) => (
                  <div key={ind}>
                    <code className={classes.subTitle}>{subItem.subTitle}</code>
                    <div className={classes.description}>{subItem.description}</div>
                  </div>
                ))}
              </div>
            );
          })}
          <textarea className={classes.textArea} type="text" id="additionalInfo" rows="8" placeholder="Enter Additional Information" />
          <Button className={classes.btn}>Update</Button>
          <Button className={classes.btnRed}>Close</Button>
        </div>
      </Panel>
    </div>
  );
};

export default withStyles(styles)(IncidentManagement);
